import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";

import { Box, Button, Grid, Paper, Stack, TextField, Typography } from "@mui/material";

export default function NotaryCardInvite({ updatedState, state, id }) {
	const [state1, setState1] = useState({ loaded: false });
	const handleChange = (prop) => (event) => {

		setState1({ ...state1, [event.target.name]: event.target.value });
	};


	useEffect(() => {
		console.log("NotaryCard", state, state.not_s, state.not_s !== undefined && state.not_s.notary_email !== undefined && state.not_s.notary_email.length > 0)
		if (!state1.loaded && state.not_s !== undefined && state.not_s.notary_email !== undefined && state.not_s.notary_email.length > 0) {
			console.log("ok")
			setState1({ ...state.not_s, loaded: true })
		}
	}, [state]);



	// useEffect(() => {
	// 	console.log("NotaryCard NotaryCard", state.not_s)
	// 	if (state.not_s && state.not_s.notary_email && state.not_s.notary_email.length > 0) {
	// 		console.log("ok")
	// 		setState1({ ...state.not_s })
	// 	}
	// }, []);

	const handleNotaryInvite = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(state1),
		};
		fetch("/api/3d17dcb0061f4d0b97d4069af3663305/" + state.deal_uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						//app.ref.ref.current.handleChangeState({ o: true, m: "Le mail a été renvoyé", s: "success" });
						window.location.href = "/11d1355181ac4376a09980601b420617/" + state.deal_uid;
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	console.log("loaded", state1.loaded)
	if (!state1.loaded) return
	//console.log("NotaryCard", state, state1)
	//if (!state.not_s_user.email) return
	return (
		<Stack direction="column" justifyContent="flex-start" alignItems="stretch" spacing={1}>
			<Typography variant="h5">Vous devez renseigner les coordonnées de votre notaire</Typography>
			<Typography variant="body1">Nous avons repris les informations de votre fiche utilisateur si vous les avez remplies</Typography>

			<div>
				<Grid container spacing={1}>
					<Grid item xs={12} sm={6}>
						<TextField
							id="notary_fname"
							name="notary_fname"
							variant="outlined"
							placeholder="Prénom"
							fullWidth
							margin="dense"
							size="small"
							value={state1.notary_fname}
							onChange={handleChange}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							id="notary_lname"
							name="notary_lname"
							variant="outlined"
							placeholder="Nom"
							fullWidth
							margin="dense"
							size="small"
							value={state1.notary_lname}
							onChange={handleChange}
						/>
					</Grid>
				</Grid>
			</div>
			<div>
				<TextField
					id="notary_raison_sociale"
					name="notary_raison_sociale"
					variant="outlined"
					placeholder="Etude"
					fullWidth
					margin="dense"
					size="small"
					value={state1.notary_raison_sociale}
					onChange={handleChange}
				/>
			</div>
			<div>
				<TextField
					id="notary_email"
					name="notary_email"
					variant="outlined"
					placeholder="Email"
					fullWidth
					margin="dense"
					size="small"
					value={state1.notary_email}
					onChange={handleChange}
				/>
			</div>{" "}
			<div>
				<TextField
					id="notary_adr1"
					name="notary_adr1"
					variant="outlined"
					style={{
						marginLeft: 0,
						marginRight: 10,
					}}
					placeholder="Adresse"
					fullWidth
					margin="dense"
					size="small"
					value={state1.notary_adr1}
					onChange={handleChange}
				/>
			</div>
			<div>
				<Grid container spacing={1}>
					<Grid item xs={12} sm={4}>
						<TextField
							id="notary_cp"
							name="notary_cp"
							variant="outlined"
							placeholder="Code postal"
							fullWidth
							margin="dense"
							size="small"
							value={state1.notary_cp}
							onChange={handleChange}
						/>
					</Grid>
					<Grid item xs={12} sm={8}>
						<TextField
							id="notary_ville"
							name="notary_ville"
							variant="outlined"
							placeholder="Ville"
							fullWidth
							margin="dense"
							size="small"
							value={state1.notary_ville}
							onChange={handleChange}
						/>
					</Grid>
					<Grid item xs={12} sm={8}>
						<Button variant="contained" onClick={handleNotaryInvite}>Inviter</Button>
					</Grid>
				</Grid>
			</div>
		</Stack>
	);
}
